<template>
  <v-icon :color="color" :size="size">
    {{ icon }}
  </v-icon>
</template>

<script>
export default {
  name: 'LegendLayerListIcon',
  props: {
    color: {
      type: String,
      default: 'rgba(0,0,0,0.7)',
    },
    layerType: {
      type: String,
    },
    size: {
      type: [Number, String],
      default: '24px',
    },
  },
  computed: {
    icon() {
      if (this.layerType === 'polygon' || this.layerType === 'multipolygon') {
        return 'mdi-vector-polygon';
      } else if (this.layerType === 'point' || this.layerType === 'multipoint') {
        return '$point';
      } else if (this.layerType === 'linestring' || this.layerType === 'multilinestring') {
        return 'mdi-vector-line';
      } else if (this.layerType === 'xyz' || this.layerType === 'wms' || this.layerType === 'wmts') {
        return '$wms';
      } else if (this.layerType === 'raster') {
        return 'mdi-checkerboard';
      } else {
        return 'mdi-layers';
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
